import { createPlugin, createComponentExtension } from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const onboardingPlugin = createPlugin({
  id: 'onboarding',
  routes: {
    root: rootRouteRef,
  },
});

export const OnboardingPage = onboardingPlugin.provide(
  createComponentExtension({
    name: 'OnboardingPage',
    component: {
      lazy: () =>
        import('./components/OnboardingPage').then(m => m.OnboardingPage),
    },
  }),
);

export const TrackPageRoute = onboardingPlugin.provide(
  createComponentExtension({
    name: 'TrackPageRoute',
    component: {
      lazy: () =>
        import('./components/OnboardingPage').then(m => m.TrackPageRoute),
    },
  }),
);

export const NpsResultsPage = onboardingPlugin.provide(
  createComponentExtension({
    name: 'NpsResultsPage',
    component: {
      lazy: () =>
        import('./components/NpsResultsPage').then(m => m.NpsResultsPage),
    },
  }),
);
